export const TRIAGE_FETCH_REQUESTED = 'TRIAGE_FETCH_REQUESTED';
export const TRIAGE_FETCH_SUCCESS = 'TRIAGE_FETCH_SUCCESS';
export const TRIAGE_FETCH_ERROR = 'TRIAGE_FETCH_ERROR';
